import { Form, Input, Modal } from 'antd'
import React, { useEffect } from 'react'

/**
 * The name of a new application. It used to accept whatever was typed —
 * including nothing — and let the editor discover afterwards that the name was
 * already taken. The names it already has are passed in, so a clash is a
 * field-level error before there is anything to undo.
 */
const AddApplicationModal = ({ modalVisible, setModalVisible, handleModalSubmit, existingNames = [] }: { modalVisible: boolean, setModalVisible: Function, handleModalSubmit: Function, existingNames?: string[] }) => {
    const [form] = Form.useForm();

    // the modal is mounted fresh each time it opens, but a remount is not
    // guaranteed — start from empty either way
    useEffect(() => {
        if (modalVisible) form.resetFields();
    }, [modalVisible, form]);

    const onFinish = ({ appName }: { appName: string }) => {
        setModalVisible(false);
        handleModalSubmit(appName.trim());
    };

    return (
        <Modal
            title="Add new application"
            open={modalVisible}
            okText="Add"
            /* the primary action runs the same validation the Enter key does,
               rather than a second path that skips it */
            onOk={() => form.submit()}
            onCancel={() => setModalVisible(false)}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={onFinish} preserve={false}>
                <Form.Item
                    name="appName"
                    label="Application name"
                    validateTrigger={['onBlur', 'onSubmit']}
                    rules={[
                        { required: true, whitespace: true, message: 'Please enter an application name' },
                        {
                            validator: (_, value) =>
                                value && existingNames.includes(value.trim())
                                    ? Promise.reject(new Error(`"${value.trim()}" already exists`))
                                    : Promise.resolve(),
                        },
                    ]}
                >
                    {/* Enter submits: the form has one field, and reaching for the
                        mouse to commit a single word is the slower path */}
                    <Input autoFocus placeholder="e.g. payments-api" onPressEnter={() => form.submit()} />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AddApplicationModal
